// extracted by mini-css-extract-plugin
module.exports = {"container":"DesignersDetailsPage_container__33INF","details":"DesignersDetailsPage_details__1tsjN","dynamicZone":"DesignersDetailsPage_dynamicZone__sOAOg"};